export default {"src":"/_next/static/media/welcome_bonus.14bebf58.svg","height":144,"width":306,"blurWidth":0,"blurHeight":0};